// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.mat-mdc-checkbox {
  display: flex;
  align-content: flex-start;
  margin: 10px 8px auto 0;
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version. */
}
.mat-mdc-checkbox .mat-checkbox-layout {
  white-space: normal;
}
.mat-mdc-checkbox .mat-checkbox-inner-container {
  margin-top: 5px;
}

mat-tab-group .mdc-tab {
  font-weight: bold;
  color: #000000;
}
mat-tab-group .mdc-tab--active {
  color: #0066b2;
}

mat-expansion-panel-header .mat-content {
  flex: 0;
  flex-basis: content;
}

/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.dictionary-toolbar {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin: 3% 0;
  min-width: 0;
  width: 100%;
}

.dictionary-toolbar__filter {
  flex: 0 1 220px;
  max-width: 220px;
  min-width: 180px;
}

.dictionary-toolbar__clear,
.dictionary-toolbar__actions,
.dictionary-toolbar__create,
.dictionary-toolbar__export,
.dictionary-toolbar__toggle {
  flex: 0 0 auto;
}

.dictionary-toolbar__clear button,
.dictionary-toolbar__create {
  background-color: white;
  border: none;
  color: #0066b2;
  cursor: pointer;
  white-space: nowrap;
}

.dictionary-toolbar__clear button:disabled {
  box-shadow: none;
  color: #707070;
  cursor: default;
}

.dictionary-toolbar__search {
  align-items: center;
  display: flex;
  flex: 1 1 320px;
  max-width: 680px;
  min-width: 280px;
}

.dictionary-toolbar__search-field {
  align-items: center;
  border: 1px solid #707070;
  display: flex;
  flex: 1 1 auto;
  height: 48px;
  min-width: 0;
}

.dictionary-toolbar__search-field input {
  border: none;
  flex: 1 1 auto;
  font-size: 14px;
  height: 100%;
  min-width: 0;
  outline: none;
  padding: 0 8px;
}

.dictionary-toolbar__clear-search {
  background: transparent;
  border: none;
  color: #0066b2;
  cursor: pointer;
  flex: 0 0 44px;
  height: 40px;
  margin: 0;
}

.dictionary-toolbar__clear-search:hover {
  color: #0b2d71;
}

.dictionary-toolbar__search-button {
  align-items: center;
  background: #0066b2;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  flex: 0 0 60px;
  height: 48px;
  justify-content: center;
}

.dictionary-toolbar__search-button:hover {
  background-color: #0b2d71;
}

.dictionary-toolbar__actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-end;
  margin-left: auto;
}

.dictionary-toolbar__toggle,
.dictionary-toolbar__create {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.dictionary-toolbar__create {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 18px;
  font-weight: normal;
  min-height: 44px;
  padding: 8px 12px;
}

@media (max-width: 900px) {
  .dictionary-toolbar__search {
    max-width: none;
  }
  .dictionary-toolbar__actions {
    justify-content: flex-start;
    margin-left: 0;
    width: 100%;
  }
}
/* Wide modal styling for Rating Class and Design Code modals */
.wide-modal .mat-mdc-dialog-container {
  max-width: 1000px;
  width: 90vw;
}

/* Consolidation Mapping add/edit modal */
.consolidation-mapping-modal .mat-mdc-dialog-container {
  width: 600px;
  max-width: 95vw;
}

/* Large component catalog modal styling */
.large-component-catalog-modal .mat-dialog-container {
  padding: 16px;
  height: 90vh;
  max-height: 95vh;
  /* Strong overrides to make the catalog component fill the dialog when used as a modal */
  overflow: auto;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container {
  padding: 8px;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .main-conatiner,
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .main-conatiner * {
  box-sizing: border-box;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .main-conatiner {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0;
  margin: 0;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .table-container {
  width: 100%;
  min-width: 0;
  display: block;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .table-inner {
  width: 100%;
}
.large-component-catalog-modal .mat-dialog-container .xlarge-component-catalog-modal .mat-dialog-container .catalog-table {
  width: 100%;
  min-width: 0;
  table-layout: auto;
}

/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version. */
/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version. */
mat-chip.mat-mdc-chip.mat-mdc-standard-chip {
  background-color: #0066b2;
  color: white;
}

mat-radio-button .mat-mdc-radio-button .mat-radio-outer-circle {
  height: 15px;
  width: 15px;
  border-color: #0066b2;
}
mat-radio-button .mat-mdc-radio-button .mat-radio-label-content {
  font-size: 9px;
  padding-left: 0px;
}
mat-radio-button .mat-mdc-radio-button .mat-radio-label {
  white-space: inherit;
  vertical-align: 0%;
  line-height: initial;
}

.mat-select-panel mat-option.mat-mdc-option {
  margin: auto 0;
  padding: 10px 20px;
  overflow: visible;
  line-height: 130%;
  word-wrap: break-word;
  white-space: pre-wrap;
  height: 100%;
}

.mat-mdc-select-panel.common-notes-panel {
  max-width: none;
  min-width: 100%;
  width: 100%;
  max-height: 250px;
}
.mat-mdc-select-panel.common-notes-panel .mat-mdc-option {
  min-height: 56px;
  height: auto;
  padding: 12px 20px;
  line-height: 1.5;
  max-width: 100%;
  width: 100%;
}
.mat-mdc-select-panel.common-notes-panel .mat-mdc-option .mdc-list-item__primary-text {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-wrap: break-word;
  max-width: 100%;
  width: 100%;
  display: block;
}
.mat-mdc-select-panel.common-notes-panel .mat-mdc-option-text {
  width: 100%;
  max-width: 100%;
}

.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value mat-chip-grid,
.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value mat-chip-row,
.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value .mat-mdc-chip-set,
.mat-mdc-form-field:has(.mat-mdc-select[panelclass*=common-notes-panel]) .mat-mdc-select-value .mat-mdc-chip {
  display: none;
}

.dropdown-close-button {
  position: sticky;
  bottom: 0;
  display: block;
  width: 100%;
  padding: 14px 16px;
  text-align: center;
  background-color: #0066CC;
  color: white;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  z-index: 100;
  transition: background-color 0.2s;
  margin: 0;
  border-radius: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.dropdown-close-button:hover {
  background-color: #0052A3;
}

.mat-snack-bar-warning .mdc-snackbar__surface {
  background: rgb(255, 248, 115);
}

.mat-snack-bar-warning .mdc-snackbar__label {
  color: black;
  font-weight: bold;
}

.mat-snack-bar-error {
  background-color: #97002e;
}
.mat-snack-bar-error .mdc-snackbar__surface {
  --mat-snackbar-container-color: \$esra-red;
  --mat-mdc-snack-bar-button-color: rgb(250, 193, 192);
}

.mat-mdc-card {
  box-shadow: none;
}

#pttable .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading {
  width: 1px;
}

#pttable .mdc-text-field--outlined {
  padding-left: 1px;
  padding-right: 1px;
}

.dialogButtons {
  padding-top: 10px;
  float: right;
}

.button-blue {
  background-color: #0066b2;
  border: 1px solid #0066b2;
  color: #ffffff;
}
.button-blue:hover {
  background-color: #0b2d71;
  cursor: pointer;
}

.button {
  margin: none;
}

.text-button {
  display: inline-block;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  outline: none;
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
}
.text-button:hover {
  color: #0b2d71;
  box-shadow: inset 0 -2px 0 0 #0b2d71;
}

.close-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
}
.close-button::before {
  font-family: "Material Icons";
  content: "close";
}
.close-button:hover {
  background-color: rgba(0, 0, 0, 0.16);
  color: #0b2d71;
}

:root ngx-slider {
  transition: none;
  margin: 15px 0px;
  height: 40px;
}
:root ngx-slider .ngx-slider-pointer {
  width: 12px;
  height: 12px;
  top: auto;
  bottom: 26px;
  background-color: #0066b2;
}
:root ngx-slider .ngx-slider-bubble {
  top: auto;
  bottom: 0px;
}
:root ngx-slider .ngx-slider-span {
  color: rgba(0, 0, 0, 0.8705882353);
  font: normal normal medium "Gotham", Arial, sans-serif;
  font-size: 11px;
}
:root ngx-slider .ngx-slider-pointer:after {
  display: none;
}
:root ngx-slider .ngx-slider-bar {
  height: 2px;
  background: rgba(125, 127, 134, 0.7019607843);
  top: auto;
  bottom: 7px;
}
:root ngx-slider .ngx-slider-selection {
  background: #0066b2;
  top: auto;
  bottom: 7px;
}

app-welding-search .mat-mdc-paginator .mat-mdc-paginator-container {
  display: flex;
  justify-content: center;
}

/* You can add global styles to this file, and also import other style files */
.left-align {
  float: left;
}

.right-align {
  float: right;
}

.text-left-align {
  text-align: left;
}

.text-right-align {
  text-align: right;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.dialogClose {
  float: right;
  cursor: pointer;
}

.dialogClose div {
  text-align: center;
  margin-top: -6px;
}

.dialogmainheader {
  padding-top: 30px;
}

.dialogmain {
  border: 1px solid gray;
  min-height: 300px;
  max-height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-top: -15px;
}

.button:enabled,
.primary:enabled,
.secondary:enabled {
  border: 1px solid #0066b2;
}

.button:disabled,
.primary:disabled,
.secondary:disabled {
  border: 1px solid #e3e3e3;
  cursor: default;
}

.container-horizontal {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.required:after {
  content: " *";
  color: red;
}

.pointer {
  cursor: pointer;
}

.progress-bar-container {
  min-height: 6px;
  margin: 1.5rem 3%;
}
.progress-bar-container div {
  height: 5px;
}

.esra-select {
  width: 80%;
}

.width-10 {
  width: 10%;
}

.esra-tooltip {
  --mat-tooltip-supporting-text-size: 0.875rem;
}
.esra-tooltip .mat-mdc-tooltip-surface {
  white-space: pre-line !important;
  max-width: 240px !important;
}

.edit-color {
  color: #0066b2;
}

.delete-color {
  color: #e21836;
}

.mat-sort-header-arrow {
  opacity: 1;
  transform: none;
  color: black;
}

.wrapped-text {
  padding: 1% 0;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.pad-LR-20 {
  padding-left: 20px;
  padding-right: 20px;
}

header,
nav#site-specific-nav,
nav#site-specific-nav.centered-nav,
main,
main.container,
menu,
footer {
  min-width: 85vw;
  min-width: 85dvw;
  max-width: 100vw;
  max-width: 100dvw;
}

.menu-list,
nav#site-specific-nav ul:not(.in-mega) > li .mega-menu,
nav#site-specific-nav ul:not(.in-mega) > li ul:not(.in-mega) {
  width: 100%;
  min-width: 0;
}

.service-selection-dialog .mat-mdc-dialog-container {
  padding: 0;
}
@media (max-width: 768px) {
  .service-selection-dialog .mat-mdc-dialog-container {
    margin: 20px;
    max-width: calc(100vw - 40px);
    max-height: calc(100vh - 40px);
  }
}
@media (max-width: 480px) {
  .service-selection-dialog .mat-mdc-dialog-container {
    margin: 10px;
    max-width: calc(100vw - 20px);
    max-height: calc(100vh - 20px);
  }
}
.service-selection-dialog .mat-mdc-dialog-content {
  padding: 0;
  margin: 0;
  overflow: visible;
}

@media (max-width: 768px) {
  .mat-mdc-dialog-container {
    border-radius: 8px;
  }
}
@media (max-width: 480px) {
  .mat-mdc-dialog-container {
    border-radius: 4px;
  }
}

/* Extra large catalog modal */
.xlarge-component-catalog-modal .mat-dialog-container,
.xlarge-component-catalog-modal .mat-mdc-dialog-container {
  padding: 0;
  width: 100vw;
  max-width: 100vw;
  height: 95vh;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.xlarge-component-catalog-modal .mat-dialog-content,
.xlarge-component-catalog-modal .mat-mdc-dialog-content {
  padding: 0;
  margin: 0;
  overflow: hidden;
  flex: 1 1 auto;
  min-height: 0;
}

.xlarge-component-catalog-modal .mat-dialog-actions,
.xlarge-component-catalog-modal .mat-mdc-dialog-actions {
  flex-shrink: 0;
  flex-grow: 0;
  margin: 0;
  padding: 0;
  min-height: auto;
}

/* Slightly larger typography and controls inside the modal for easier selection */
.xlarge-component-catalog-modal table {
  font-size: 1.05rem;
}

.xlarge-component-catalog-modal .mat-form-field,
.xlarge-component-catalog-modal .search-input-container {
  transform: scale(1.02);
}

/* When the catalog component is hosted inside a modal use these styles */
.table-container.modal-mode {
  display: flex;
  flex-direction: column;
  height: 90%; /* occupy 90% of the dialog */
}

.table-container.modal-mode .table-inner {
  flex: 1 1 auto;
  min-height: 0; /* allow flex child to shrink for scrolling */
  overflow: auto;
  /* ensure horizontal scrolling is possible and visible */
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-container.modal-mode .catalog-table {
  /* Allow the table to be wider than the dialog so users get a spacious layout
     and can horizontally scroll inside the modal. Increase min-width to better
     match the dialog's larger layout. */
  width: auto; /* let content set the width */
  min-width: 0; /* don't force a large min-width in modal; allow dialog to constrain width */
  table-layout: auto; /* allow columns to size naturally */
}

/* Optional: style the horizontal scrollbar inside the table-inner for clarity */
.table-container.modal-mode .table-inner::-webkit-scrollbar {
  height: 12px;
}

.table-container.modal-mode .table-inner::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.table-container.modal-mode .modal-confirm-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

/* Make the middle area wider in the extra-large catalog modal: place filters and
   table side-by-side and let the table take the remaining width. */
.xlarge-component-catalog-modal .main-conatiner .middle-container {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.xlarge-component-catalog-modal .main-conatiner .filter-group-container {
  /* keep filter column compact in modal so table has more room */
  flex: 0 0 260px;
  max-width: 260px;
}

.xlarge-component-catalog-modal .main-conatiner .table-container {
  /* allow table container to expand and use modal-mode rules for internal scrolling */
  flex: 1 1 auto;
  min-width: 0; /* allow flex child to shrink for proper overflow handling */
}

/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.ribbon-wrap {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.corner-ribbon {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translateX(30%) rotate(-45deg);
  transform-origin: bottom left;
  margin: 0;
  padding: 7px 0;
  width: 110px;
  text-align: center;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 11px;
  letter-spacing: 0.5px;
  color: white;
  pointer-events: auto;
  cursor: default;
}
.corner-ribbon::before, .corner-ribbon::after {
  content: "";
  position: absolute;
  top: 0;
  margin: 0 -1px;
  width: 100%;
  height: 100%;
}
.corner-ribbon::before {
  right: 100%;
}
.corner-ribbon::after {
  left: 100%;
}
.corner-ribbon.corner-ribbon--draft {
  background-color: #e65100;
}
.corner-ribbon.corner-ribbon--draft::before, .corner-ribbon.corner-ribbon--draft::after {
  background: #e65100;
}
.corner-ribbon.corner-ribbon--retired {
  background-color: #97002e;
}
.corner-ribbon.corner-ribbon--retired::before, .corner-ribbon.corner-ribbon--retired::after {
  background: #97002e;
}
.corner-ribbon.corner-ribbon--archived {
  background-color: #8c8f93;
}
.corner-ribbon.corner-ribbon--archived::before, .corner-ribbon.corner-ribbon--archived::after {
  background: #8c8f93;
}

/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.tab-actions {
  padding: 1rem 0;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e0e0e0;
  margin-top: 1rem;
}
.tab-actions .save-comments-btn {
  background-color: #ff6b35;
  color: white;
  padding: 0.5rem 1rem;
  font-weight: 500;
  text-transform: none;
  border-radius: 4px;
}
.tab-actions .save-comments-btn mat-icon {
  margin-right: 0.5rem;
}
.tab-actions .save-comments-btn:hover {
  background-color: rgb(255, 69.6336633663, 2);
}
.tab-actions .save-comments-btn:disabled {
  background-color: #ccc;
  color: #666;
}
.tab-actions .auto-save-indicator {
  display: flex;
  align-items: center;
  color: #4caf50;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  background-color: #f1f8e9;
  border-radius: 4px;
  border: 1px solid #c8e6c9;
}
.tab-actions .auto-save-indicator mat-icon {
  margin-right: 0.5rem;
  font-size: 1.2rem;
}
.tab-actions .auto-save-indicator mat-icon.spinning {
  animation: spin 1s linear infinite;
}
.tab-actions .auto-save-indicator span {
  font-weight: 500;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.save-all-comments {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 1000;
}
.save-all-comments .save-all-btn {
  background-color: #4caf50;
  color: white;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  text-transform: none;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.save-all-comments .save-all-btn mat-icon {
  margin-right: 0.5rem;
}
.save-all-comments .save-all-btn:hover {
  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
}
.save-all-comments .save-all-btn:disabled {
  background-color: #ccc;
  color: #666;
  box-shadow: none;
}

.header-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.debug-btn {
  margin: 10px;
}

.left-pipe-class-details {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.left-pipe-class-details .pipe-class-specification {
  color: #e3e3e3;
}
.left-pipe-class-details .pipe-class-name {
  font-weight: bold;
  font-size: 130%;
}

.right-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.right-container .lifecycle-badge-row {
  text-align: right;
}
.right-container .lifecycle-badge-row:has(.lifecycle-badge) {
  margin-bottom: 6px;
}
.right-container .pipe-class-status-section {
  text-align: right;
  margin-bottom: 6px;
}
.right-container .pipe-class-status-section .pipe-class-status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.right-container .pipe-class-status-section .pipe-class-status-badge.pipe-class-status-badge--draft {
  color: #e65100;
  background-color: #fff3e0;
  border: 1px solid #faab18;
}
.right-container .pipe-class-status-section .pipe-class-status-badge.pipe-class-status-badge--retired {
  color: #97002e;
  background-color: #fff0f3;
  border: 1px solid #f4a3b5;
}
.right-container .pipe-class-status-section .pipe-class-status-badge.pipe-class-status-badge--archived {
  color: #8c8f93;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
}
.right-container .export-buttons-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.right-container .export-buttons-container .edit-button-container {
  display: flex;
  justify-content: flex-end;
}
.right-container .export-buttons-container .edit-button-container .edit-mode-button {
  background-color: #0066b2;
  color: white;
  font-weight: 500;
  padding: 0.5rem 1.5rem;
}
.right-container .export-buttons-container .edit-button-container .edit-mode-button:hover {
  background-color: rgb(0, 72.7752808989, 127);
}

#mat-group-wrapper {
  width: 100%;
}

.branch-table-container {
  text-align: center;
}

.back-button {
  margin-bottom: 1.5rem;
  cursor: pointer;
  color: #0066b2;
  border-color: #0066b2;
  background-color: #fff;
  border-radius: 5px;
}

.no-branch-table {
  margin: 5% 0 0 0;
}

.container {
  max-width: 100%;
}

.edit-header {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}
.edit-header .left-pipe-class-details .specification-code,
.edit-header .left-pipe-class-details .creation-date,
.edit-header .left-pipe-class-details .author {
  color: #0066b2;
  font-weight: 500;
}
.edit-header .left-pipe-class-details .specification-code strong,
.edit-header .left-pipe-class-details .creation-date strong,
.edit-header .left-pipe-class-details .author strong {
  color: #0066b2;
  font-weight: 600;
}
.edit-header .left-pipe-class-details .specification-code .value-highlight,
.edit-header .left-pipe-class-details .creation-date .value-highlight,
.edit-header .left-pipe-class-details .author .value-highlight {
  color: #0066b2;
  font-weight: 500;
}
.edit-header .left-pipe-class-details .pipe-class {
  color: #0066b2;
  font-weight: 700;
  font-size: 1.2rem;
}
.edit-header .left-pipe-class-details .pipe-class strong {
  color: #0066b2;
  font-weight: 700;
  font-size: 1.2rem;
}
.edit-header .left-pipe-class-details .pipe-class .value-highlight {
  color: #0066b2;
  font-weight: 700;
  font-size: 1.2rem;
}
.edit-header .right-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-end;
}
.edit-header .right-container .status-section .status {
  color: #333;
  font-weight: 400;
  text-align: right;
}
.edit-header .right-container .status-section .status strong {
  color: #666;
  font-weight: 600;
}
.edit-header .right-container .status-section .status .rejected-status, .edit-header .right-container .status-section .status .retired-status, .edit-header .right-container .status-section .status .published-status, .edit-header .right-container .status-section .status .approval-pending-comments-status, .edit-header .right-container .status-section .status .ready-to-publish-status, .edit-header .right-container .status-section .status .review-pending-comments-status, .edit-header .right-container .status-section .status .review-rejected-status, .edit-header .right-container .status-section .status .review-status, .edit-header .right-container .status-section .status .draft-status {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.edit-header .right-container .status-section .status .draft-status {
  color: #751569;
  background-color: #f5e8f4;
  border: 1px solid #c98ac4;
}
.edit-header .right-container .status-section .status .review-status {
  color: #1a7fa0;
  background-color: #e5f6fd;
  border: 1px solid #5cc0e7;
}
.edit-header .right-container .status-section .status .review-rejected-status {
  color: #a02020;
  background-color: #fdf0f0;
  border: 1px solid #d9534f;
}
.edit-header .right-container .status-section .status .review-pending-comments-status {
  color: #7a5000;
  background-color: #fdf6e3;
  border: 1px solid #e8a838;
}
.edit-header .right-container .status-section .status .ready-to-publish-status {
  color: #0066b2;
  background-color: #e3f0fb;
  border: 1px solid #80b8df;
}
.edit-header .right-container .status-section .status .approval-pending-comments-status {
  color: #2a5a8a;
  background-color: #eaf2fb;
  border: 1px solid #5a8fcb;
}
.edit-header .right-container .status-section .status .published-status {
  color: #1a6b3a;
  background-color: #e8f5ee;
  border: 1px solid #7ebc9a;
}
.edit-header .right-container .status-section .status .retired-status {
  color: #555;
  background-color: #f0f0f0;
  border: 1px solid #bbb;
}
.edit-header .right-container .status-section .status .rejected-status {
  color: #9b2020;
  background-color: #fdf0f0;
  border: 1px solid #e09090;
}
.edit-header .right-container .edit-action-buttons {
  display: flex;
  gap: 15px;
  align-items: center;
}
.edit-header .right-container .edit-action-buttons .cancel-btn {
  border: 1px solid #0066b2;
  color: #0066b2;
  background-color: white;
  padding: 8px 24px;
  font-weight: 500;
  text-transform: none;
}
.edit-header .right-container .edit-action-buttons .cancel-btn:hover {
  background-color: rgba(0, 102, 178, 0.04);
}
.edit-header .right-container .edit-action-buttons .save-btn {
  background-color: #0066b2;
  color: white;
  padding: 8px 24px;
  font-weight: 500;
  text-transform: none;
}
.edit-header .right-container .edit-action-buttons .save-btn:hover {
  background-color: rgb(0, 72.7752808989, 127);
}
.edit-header .right-container .review-action-buttons {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
}
.edit-header .right-container .cancel-btn {
  border: 1px solid #0066b2;
  color: #0066b2;
  background-color: white;
  padding: 8px 24px;
  font-weight: 500;
  text-transform: none;
}
.edit-header .right-container .cancel-btn:hover {
  background-color: rgba(0, 102, 178, 0.04);
}
.edit-header .right-container .publish-btn {
  background-color: #0066b2;
  color: white;
  padding: 8px 24px;
  font-weight: 500;
  text-transform: none;
}
.edit-header .right-container .publish-btn mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  margin-right: 4px;
  vertical-align: middle;
}
.edit-header .right-container .publish-btn:hover:not(:disabled) {
  background-color: rgb(0, 72.7752808989, 127);
}
.edit-header .right-container .publish-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.edit-header .right-container .cancel-btn:disabled,
.edit-header .right-container .cancel-btn:disabled:hover,
.edit-header .right-container .save-btn:disabled,
.edit-header .right-container .save-btn:disabled:hover {
  pointer-events: auto;
  cursor: not-allowed;
  opacity: 0.6;
}
.edit-header .right-container .cancel-btn:disabled,
.edit-header .right-container .cancel-btn:disabled:hover {
  color: #757575;
  border-color: #bdbdbd;
  background-color: #f5f5f5;
}
.edit-header .right-container .save-btn:disabled,
.edit-header .right-container .save-btn:disabled:hover {
  color: #fff;
  background-color: #9e9e9e;
}

.reviewer-approvals {
  margin-top: 8px;
}
.reviewer-approvals--full-width {
  width: 100%;
  margin-top: 12px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
}
.reviewer-approvals--full-width .approval-list li {
  padding: 4px 0;
}
.reviewer-approvals .approval-list {
  list-style: none;
  padding: 0;
  margin: 4px 0 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}
.reviewer-approvals .approval-list li {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.approval-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid transparent;
}
.approval-badge .badge-icon {
  font-size: 0.85rem;
  width: 0.85rem;
  height: 0.85rem;
  line-height: 0.85rem;
}
.approval-badge.approval-pending {
  background-color: #f5f5f5;
  color: #616161;
  border-color: #bdbdbd;
}
.approval-badge.approval-approved {
  background-color: #e8f5e9;
  color: #2e7d32;
  border-color: #a5d6a7;
}
.approval-badge.approval-rejected {
  background-color: #fdf0f0;
  color: #9b2020;
  border-color: #e09090;
}

.pipe-class-page-skeleton,
.pipe-class-tab-content-skeleton {
  padding: 16px 0;
}

.pipe-class-load-error {
  padding: 24px 0;
  color: #97002e;
}

.skeleton-header-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 20px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.skeleton-header-line {
  width: 60%;
  height: 18px;
  border-radius: 4px;
}

.skeleton-header-line-wide {
  width: 40%;
}

.skeleton-header-line-narrow {
  width: 20%;
}

.skeleton-tab-header {
  display: flex;
  gap: 24px;
  padding-bottom: 16px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.skeleton-tab-label {
  width: 90px;
  height: 20px;
  border-radius: 4px;
}

.skeleton-row {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.skeleton-cell {
  flex: 1;
  height: 32px;
  border-radius: 4px;
}

.skeleton-cell-narrow {
  flex: 0 0 12%;
}

.skeleton-header-line,
.skeleton-tab-label,
.skeleton-cell {
  background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%);
  background-size: 200% 100%;
  animation: pipe-class-skeleton-shimmer 1.4s ease-in-out infinite;
}

@keyframes pipe-class-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.skeleton-loading-hint {
  font-size: 13px;
  color: #888;
  margin: 10px 0 4px;
  font-style: italic;
}

.reviewer-action-panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  margin-top: 4px;
}
.reviewer-action-panel .my-approval-state {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  color: #555;
}
.reviewer-action-panel .my-approval-state::before {
  content: "Your review:";
  font-weight: 500;
  color: #666;
}
.reviewer-action-panel .reviewer-buttons {
  display: flex;
  gap: 6px;
  align-items: center;
}
.reviewer-action-panel .reviewer-buttons .inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
}
.reviewer-action-panel .reviewer-buttons .reviewer-btn {
  font-size: 0.78rem;
  padding: 0 10px;
  height: 30px;
  line-height: 28px;
  min-width: 0;
}
.reviewer-action-panel .reviewer-buttons .reviewer-btn mat-icon {
  font-size: 0.9rem;
  width: 0.9rem;
  height: 0.9rem;
  line-height: 0.9rem;
  margin-right: 2px;
}
.reviewer-action-panel .reviewer-buttons .approve-btn {
  color: #2e7d32;
  border-color: #a5d6a7;
}
.reviewer-action-panel .reviewer-buttons .approve-btn:hover:not([disabled]) {
  background-color: #f1f8f1;
}
.reviewer-action-panel .reviewer-buttons .reject-btn {
  color: #9b2020;
  border-color: #e09090;
}
.reviewer-action-panel .reviewer-buttons .reject-btn:hover:not([disabled]) {
  background-color: #fdf6f6;
}
.reviewer-action-panel .reviewer-buttons .reset-btn {
  color: #616161;
}
.reviewer-action-panel .reviewer-buttons .reset-btn:hover:not([disabled]) {
  background-color: #f5f5f5;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
